import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import useTranslateMethod from '../../../../utils/helpers/useTranslateMethod.jsx';
import DataGrid from '../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import {
  dataGridDateSorter,
  dataGridTextSorter,
} from '../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { IconButton } from '../../../common/controls/Controls.jsx';
import { FileSearchOutlined } from '@ant-design/icons';

const NewsArchiveTable = ({ news, onDetailClick, isEnglish }) => {
  const { t } = useTranslation();

  const titleFilterProps = useDataGridTextFilter(
    useTranslateMethod('title_sk', 'title_en'),
  );
  const addedFilterProps = useDataGridDateRangeFilter('created_at');
  const fullNameFilterProps = useDataGridTextFilter('fullName');

  function showDetail(news) {
    isEnglish ? onDetailClick(news.slug_en) : onDetailClick(news.slug_sk);
  }

  const columns = [
    {
      title: t('Názov'),
      dataIndex: useTranslateMethod('title_sk', 'title_en'),
      minWidth: 250,
      sorter: dataGridTextSorter(useTranslateMethod('title_sk', 'title_en')),
      ...titleFilterProps,
    },
    {
      title: t('Pridaná'),
      width: 150,
      dataIndex: 'created_at',
      render: (value) => {
        return dayjs(value).format('D.M.YYYY');
      },
      sorter: dataGridDateSorter('created_at'),
      minWidth: 100,
      ...addedFilterProps,
    },
    {
      title: t('Autor'),
      dataIndex: 'fullName',
      minWidth: 200,
      sorter: dataGridTextSorter('fullName'),
      ...fullNameFilterProps,
    },
  ];

  const customSettings = (row) => {
    return (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail')}
          onClick={(e) => {
            e.stopPropagation();
            onDetailClick(row.slug_sk);
          }}
        />
      </div>
    );
  };

  return (
    <DataGrid
      customSettings={customSettings}
      dataSource={news || []}
      columns={columns}
      onRowClick={(news) => {
        showDetail(news);
      }}
      uniqueTableId={'news-archive-table'}
    />
  );
};

NewsArchiveTable.propTypes = {
  news: PropTypes.array,
  onDetailClick: PropTypes.func,
  isEnglish: PropTypes.bool,
};

export default NewsArchiveTable;
